module.exports = __webpack_public_path__ + "img/product_right_settle_bg.f305be9.png";